import './App.css'
import 'dayjs/locale/fa'
import { Watermark} from "antd";
import EnterGate from "./EnterGate";
import FallingFlowersAndHearts from "./FallingFlowers";
import Watch from "./Watch";
import EventList from "./EventList";
import GlowTags from "./GlowTags";


function App() {
  return (
      <EnterGate buttonText="💌" musicSrc="/music.mp3" musicVolume={1} fadeDurationMs={800}>
          <FallingFlowersAndHearts count={25} />
          <Watermark
              font={{ color: "rgba(0,0,0,0.17)", fontSize: 12 }}
              content={["سچصییی", "💓🧡🩷سانا قوربان اولسونن💖💞❤️"]}>
                <div className='center'>
                    <div className="glass">
                         <Watch />
                         <EventList />
                         <GlowTags />
                    </div>
                </div>
          </Watermark>
      </EnterGate>
  )
}

export default App